import { Injectable, TemplateRef, ViewContainerRef } from "@angular/core";
import { CustomModalHeaderComponent } from "../components/custom-modal-header/custom-modal-header.component";

@Injectable({
    providedIn: "root"
})
export class CustomModalHeaderService {
    public createTitleTemplate(viewContainerRef: ViewContainerRef, title: string, tooltip: string = null): TemplateRef<any> {
        const titleInstance = viewContainerRef.createComponent(CustomModalHeaderComponent);
        titleInstance.instance.title = title;
        titleInstance.instance.tooltip = tooltip;
        titleInstance.changeDetectorRef.detectChanges();

        return titleInstance.instance.titleTemplate;
    }
}
